/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiSegmentResult,
    InternalApiSegmentResultFromJSON,
    InternalApiSegmentResultToJSON,
} from '../models';

export interface FindPersonSegmentResultsRequest {
    personId: string;
}

/**
 * 
 */
export class PersonSegmentResultsApi extends runtime.BaseAPI {

    /**
     * Segments applied to the Person
     */
    async findPersonSegmentResultsRaw(requestParameters: FindPersonSegmentResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiSegmentResult>>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findPersonSegmentResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/segments`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiSegmentResultFromJSON));
    }

    /**
     * Segments applied to the Person
     */
    async findPersonSegmentResults(requestParameters: FindPersonSegmentResultsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiSegmentResult>> {
        const response = await this.findPersonSegmentResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
